import axios from "axios"
import { retrieveUserToken } from "@/utils/secureStorage"

function timeout(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms))
}

async function responseHandler(resp) {
  return resp
}

async function errorHandler(e) {
  throw e
}

function getAccessToken() {
  let token = retrieveUserToken()
  if (token) {
    return "Bearer " + token
  } else {
    return null
  }
}

const client = {
  async postUser(url, data, config = {}) {
    return axios
      .post(url, data, config)
      .then(responseHandler)
      .catch(errorHandler)
  },
  async get(url, config) {
    axios.defaults.headers.common.Authorization = getAccessToken()
    try {
      return await axios.get(url, config);
    } catch (error) {
      // get error using axios
    }
  },
  async post(url, data, config = {}) {
    axios.defaults.headers.common.Authorization = getAccessToken()
    return axios
      .post(url, data, config)
      .then(responseHandler)
      .catch(errorHandler)
  },
  async put(url, data, config = {}) {
    axios.defaults.headers.common.Authorization = getAccessToken()
    return axios
      .put(url, data, config)
      .then(responseHandler)
      .catch(errorHandler)
  },
  async delete(url, data, config = {}) {
    axios.defaults.headers.common.Authorization = getAccessToken()
    return axios.delete(url, config).then(responseHandler).catch(errorHandler)
  },
}

export default client
